import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { isValidElement } from 'react';
import { Transition } from 'react-transition-group';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var defaultTransitionStyles = {
  entering: {},
  entered: {},
  exiting: {},
  exited: {},
  unmounted: {}
};

var TransitionBase = function TransitionBase(_a) {
  var _b = _a,
      children = _b.children,
      inProp = _b.in,
      _b$timeout = _b.timeout,
      timeout = _b$timeout === void 0 ? 0 : _b$timeout,
      _b$transitionStyles = _b.transitionStyles,
      transitionStyles = _b$transitionStyles === void 0 ? defaultTransitionStyles : _b$transitionStyles,
      _b$transitionProperti = _b.transitionProperties,
      transitionProperties = _b$transitionProperti === void 0 ? "opacity" : _b$transitionProperti,
      props = __objRest(_b, ["children", "in", "timeout", "transitionStyles", "transitionProperties"]);

  var child = React.Children.only(children);

  if (!
  /*#__PURE__*/
  isValidElement(child)) {
    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, null, child)
    );
  }

  var transitionPropertiesArray = typeof transitionProperties === "string" ? [transitionProperties] : transitionProperties;
  return (
    /* @__PURE__ */
    React.createElement(Transition, __spreadValues({
      appear: true,
      in: inProp,
      timeout: timeout
    }, props), function (state, childProps) {
      return (
        /*#__PURE__*/
        React.cloneElement(child, __spreadValues({
          style: __spreadValues(__spreadValues({
            visibility: state === "exited" && !inProp ? "hidden" : void 0,
            transition: transitionPropertiesArray.map(function (property) {
              return property + " " + timeout + "ms ease-in-out";
            })
          }, transitionStyles[state]), child.props.style)
        }, childProps))
      );
    })
  );
};

export { TransitionBase };